import { render, staticRenderFns } from "./Linkblok.vue?vue&type=template&id=3741f15f&"
import script from "./Linkblok.vue?vue&type=script&lang=js&"
export * from "./Linkblok.vue?vue&type=script&lang=js&"
import style0 from "./Linkblok.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports